import { Flex, Heading, Spinner, Stack } from '@chakra-ui/react';
import { getStorage, STORAGE_KEY } from 'helpers/storage';
import { useTranslation } from 'react-i18next';

import UploadInput from './UploadInput';
const Upload = () => {
  const { t } = useTranslation();
  const SpinnerCentered = () => (
    <Flex
      pos='fixed'
      zIndex='999'
      top='0'
      right='0'
      bottom='0'
      left='0'
      align='center'
      justify='center'
      w='100vw'
      h='100vh'
    >
      <Spinner size='xl' speed='0.65s' thickness='4px' />
    </Flex>
  );

  return getStorage(STORAGE_KEY.TOKEN) ? (
    <Stack>
      <Stack>
        <Flex
          mb={{
            base: '0.8rem',
            md: '1rem',
            xl: '1.25rem',
            '2xl': '1.25rem',
          }}
        >
          <Heading as='h3' mr='1rem' fontWeight={'bold'} size='md'>
            {t('upload.title')}
          </Heading>
        </Flex>

        <UploadInput />
      </Stack>
    </Stack>
  ) : (
    <SpinnerCentered />
  );
};

export default Upload;
